import React, { useEffect } from "react";

const Repeat = ({ loadAll, dualScreen, getStatsDashboard, sendDashboardToDualScreen }) => {
	useEffect(() => {
		const interval = setInterval(async () => {
			loadAll();
			if (dualScreen)
				getStatsDashboard().then((res) => {
					sendDashboardToDualScreen(res);
				});
		}, 10000);
		return () => clearInterval(interval);
	}, [dualScreen]);
	return <> </>;
};

export default Repeat;
